import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["contactSelect", "newTenantFields", "nameInput", "emailInput"]

  connect() {
    this.syncNewTenantFields()
  }

  contactChanged() {
    this.syncNewTenantFields()
  }

  syncNewTenantFields() {
    const isNewTenant = !this.contactSelectTarget.value

    this.newTenantFieldsTarget.hidden = !isNewTenant
    this.nameInputTarget.required = isNewTenant
    this.emailInputTarget.required = isNewTenant

    if (!isNewTenant) {
      this.nameInputTarget.value = ""
      this.emailInputTarget.value = ""
    }
  }
}
